import { ReactNode } from "react";
import * as S from "./styles";
import { useTranslation } from "react-i18next";

interface CardButtonProps {
  title: string;
  description: string;
  href: string;
  children: ReactNode;
}

export function CardLinkButton({
  title,
  description,
  href,
  children,
}: CardButtonProps) {
  const { t } = useTranslation();

  return (
    <S.CardButtonContainer to={href}>
      <S.IconCircle>{children}</S.IconCircle>
      <S.CardButtonInfoContainer>
        <S.CardButtonTitle>{title}</S.CardButtonTitle>
        <S.CardButtonText>{description}</S.CardButtonText>
        <S.View>{t("view")}</S.View>
      </S.CardButtonInfoContainer>
    </S.CardButtonContainer>
  );
}
